import { useInfiniteQuery } from '@tanstack/react-query';

import { GetUserProductsDocument, GetUserProductsQuery } from '@phoenix/team-m/my-tool-shed/frontend/domain/generated/graphql';
import { mapToProductListItem } from '@phoenix/team-m/my-tool-shed/frontend/util/product/product.mapper';

import { useQueryFetcher } from '../use-query-fetcher';

const PRODUCTS_PER_CALL = 10;
export const PRODUCTS_QUERY_KEY = 'getUserProducts';

export const usePaginatedUserProducts = ({ limit = PRODUCTS_PER_CALL, withBasicInfo = false } = {}) => {
  const queryFetcher = useQueryFetcher<GetUserProductsQuery>(GetUserProductsDocument);

  const { data, isError, isLoading, isSuccess, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
    queryKey: [PRODUCTS_QUERY_KEY, limit, withBasicInfo ? 'basic' : 'extended'],
    queryFn: async ({ pageParam }) => queryFetcher({ cursor: pageParam, withBasicInfo, limit }),
    getNextPageParam: (lastPage) => lastPage?.data?.user?.products?.pageInfo.next,
    select: (data) => ({ ...data, pages: data.pages.map((page) => page.data?.user?.products?.items.map(mapToProductListItem)) }),
  });

  return {
    pages: data?.pages,
    isEmpty: isSuccess ? !data?.pages?.[0]?.length : null,
    isLoading,
    fetchNextPage,
    isFetchingNextPage,
    isError,
    hasNextPage,
  };
};
